import { useRef } from "react"

import Style from "./style"

import usePostEventMove from "entity/event/usePostEventMove"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"

const ChangeTimerModal = ({ closeEvent }) => {
    const levelRef = useRef()
    const minuteRef = useRef()
    const secRef = useRef()

    const [putTimer] = usePostEventMove(levelRef, minuteRef, secRef)

    return (
        <DefaultModal title="레벨 이동" closeEvent={closeEvent}>
            <Style.Wrapper>
                <input placeholder="레벨 입력" ref={levelRef} />
                <input placeholder="분 입력" ref={minuteRef} />
                <input placeholder="초 입력" ref={secRef} />
                <DefaultButton small fitWidth clickEvent={putTimer}>적용</DefaultButton>
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default ChangeTimerModal